import React, { useState, useEffect, useRef, useCallback, useLayoutEffect, Ref } from "react";
import ReactDOMServer from "react-dom/server";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import dedent from 'dedent';
import axios from "axios";
function TestArea() {
    const [activeMenu, setActiveMenu] = useState(0);

    const [themeList, setThemeList] = useState([
        {
            group: "buttons", title: "Кнопки", tag: "button", list: [
                { text: "Текст", class: "button" },
                { text: "Текст", class: "buttonS" },
                { text: "Текст", class: "buttonB" },
                { text: "Текст", class: "buttonBS" }
            ]
        },
        {
            group: "text", title: "Тексты", tag: "p", list: [
                {
                    text: "Lorem ipsum nec suspendisse orci lobortis at fringilla sit maecenas sapien felis euismod id fringilla facilisis feugiat convallis venenatis etiam neque erat adipiscing imperdiet velit lacus ultrices scelerisque vulputate curabitur condimentum ut dui amet bibendum dui",
                    class: "text"
                },
                {
                    text: "Lorem ipsum nec suspendisse orci lobortis at fringilla sit maecenas sapien felis euismod id fringilla facilisis feugiat convallis venenatis etiam neque erat adipiscing imperdiet velit lacus ultrices scelerisque vulputate curabitur condimentum ut dui amet bibendum dui",
                    class: "textS"
                },
                {
                    text: "Lorem ipsum nec suspendisse orci lobortis at fringilla sit maecenas sapien felis euismod id fringilla facilisis feugiat convallis venenatis etiam neque erat adipiscing imperdiet velit lacus ultrices scelerisque vulputate curabitur condimentum ut dui amet bibendum dui",
                    class: "textP"
                },
            ]
        },
        {
            group: "heads", title: "Заголовки", tag: "h4", list: [
                { text: "Заголовок", class: "headTitle" },
                { text: "Заголовок", class: "headTitleM" },
                { text: "Заголовок", class: "headTitleS" },
            ]
        }

    ])

    const copyTag = (html: string) => {
        navigator.clipboard.writeText(html.replace(/class=/g, 'className='));
    };

    return (
        <React.Fragment>
            <div className="filters">
                <button
                    className={activeMenu === 0 ? "active button" : "button"}
                    onClick={() => setActiveMenu(0)}
                >Тема</button>
                <button
                    className={activeMenu === 1 ? "active button" : "button"}
                    onClick={() => setActiveMenu(1)}
                >Полезные утилиты</button>
                <button
                    className={activeMenu === 2 ? "active button" : "button"}
                    onClick={() => setActiveMenu(2)}
                >Хранилища</button>
            </div>

            {activeMenu === 0 ? (
                <div className="themeList">
                    <p>Чтобы скопировать html элемента - нажмите на него</p>
                    {themeList.map((item, index) => {
                        const Element = item.tag as keyof JSX.IntrinsicElements;
                        return (
                            <div className="themeRow" key={item.group}>
                                <h4 className="title">{item.title}</h4>
                                {item.list.map((child, cIndex) => {
                                    const { text, ...validProps } = child;
                                    const reactElement = React.createElement(Element, { ...validProps, onClick: (e) => copyTag((e.target as HTMLElement).outerHTML) }, text);
                                    return (
                                        <div className="rowItem" key={cIndex}>
                                            {reactElement}
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}
                </div>
            ) : (activeMenu === 1) ? (
                    <div className="storeGuide">
                        <div className="step">
                            <h4>1) Хук валидации</h4>
                            <p className="text">Хук useValidate позволяет быстро и просто настроить валидацию,
                                в него достаточно передать несколько параметров, он возвращает промис(validate) и список ошибок(errors),
                                    при вызове validate нужно передать данные которые нужно валидировать, а в useValidate - список параметров для валидации:</p>
                            <span className="path">/ReactComponents/hooks/useValidate.tsx</span>
                            <SyntaxHighlighter language="tsx" style={oneDark} customStyle={{ fontSize: "18px" }}>
                                {dedent(`
                                        PropsModel: МАССИВ
                                        { 
                                            key: string,  - [НАЗВАНИЕ КЛЮЧА ИЗ ДАННЫХ КОТОРЫЕ БУДУТ ВАЛИДИРОВАТЬСЯ]
                                            name: string, - [НАЗВАНИЕ ПОЛЯ, ДЛЯ ТОГО ЧТОБЫ ЕСЛИ ВЫ НЕ УКАЗАЛИ text, ХУК НАПИШЕТ ОШИБКУ - "Заполните поле ...ваше name"]
                                            fn?: (value) => any, - [ФУНКЦИЯ УСЛОВИЯ ВАЛИДАЦИИ, НЕОБЯЗАТЕЛЬНО, ХУК ПРИ ОТСУТСТВИИ ПРОВАЛИДИРУЕТ НА ПУСТОЕ ПОЛЕ]
                                            text?: string - [ТЕКСТ ОШИБКИ, НЕОБЯЗАТЕЛЬНО]
                                        }
                                `)}
                            </SyntaxHighlighter>
                            <SyntaxHighlighter language="tsx" style={oneDark} customStyle={{ fontSize: "18px" }}>
                                {dedent(`
                                    const { validate, errors } = useValidate([
                                        { key: "name", name: "Имя", fn: (value) => value , text: "Заполните поле Имя" },
                                        { key: "age", name: "Возраст", fn: (value) => value > 18 , text: "Заполните поле Имя" }
                                    ])

                                    const data = {
                                        name: "",
                                        age: "17"
                                    }

                                    [ФУНКЦИЯ ОБЯЗАТЕЛЬНО ДОЛЖНА БЫТЬ АСИНХРОННОЙ (async)]
                                    const validation = async (data) => {
                                        try { <-- [ЗАПУСК validate, ЕСЛИ ОНО ВЫПОЛНИТСЯ УСПЕШНО - КОД В try ПРОДОЛЖИТСЯ, ИНАЧЕ - ПОПАДЕТ В catch]
                                            await validate(data);
                                            console.log("Успех");
                                        }catch(err) { <-- [СЮДА ПОПАДЕТ ЕСЛИ ПОЛЯ НЕ ПРОШЛИ ВАЛИДАЦИЮ]
                                            console.log(errors); 
                                        }
                                    }
                                `)}
                            </SyntaxHighlighter>
                    </div>
                </div>
            ) : (activeMenu === 2) ? (
                <div className="storeGuide">
                    <div className="step">
                        <h4>1)</h4>
                        <p className="text">Все хранилища(слайсы) описываются в /ReactComponents/Store...
                            store.ts - объединение хранилищ(слайсов), в нем вы записываете название своего слайса
                            и ссылку на него
                        </p>
                        <span className="path">[/ReactComponents/Store/store.ts]</span>
                        <SyntaxHighlighter language="tsx" style={oneDark} customStyle={{ fontSize: "18px" }}>
                            {dedent(`
                                import { configureStore } from "@reduxjs/toolkit";
                                import DraftSlice from "./DraftSlice";

                                export const store = configureStore({
                                    reducer: {
                                        Draft: DraftSlice
                                    },
                                });

                                export type RootState = ReturnType<typeof store.getState>;
                                export type AppDispatch = typeof store.dispatch;
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <div className="step">
                        <h4>2)</h4>
                        <p className="text">Есть шаблон хранилища(слайс), на основе него вы можете создавать свои:</p>
                        <span className="path">[/ReactComponents/Store/DraftSlice.ts]</span>
                        <SyntaxHighlighter language="tsx" style={oneDark} customStyle={{ fontSize: "18px" }}>
                            {dedent(
                                `
                                    import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";

                                    interface NotificationState { [МОДЕЛЬ ХРАНИЛИЩА]
                                        num: number
                                    }

                                    const initialState: NotificationState = { [НАЧАЛЬНЫЕ ЗНАЧЕНИЯ]
                                        num: 0
                                    };

                                    const DraftSlice = createSlice({
                                        name: "Draft", [ИДЕНТИФИКАТОР]
                                        initialState,
                                        reducers: {
                                            update: (state, action: PayloadAction<any>) => {
                                                state.num = action.payload;
                                                [state - ДАННЫЕ В ХРАНИЛИЩЕ,
                                                action.payload - ДАННЫЕ КОТОРЫЕ ВЫ ОТПРАВИЛИ В МЕТОД update]
                                            },
                                        }
                                    });

                                    export const { update } = DraftSlice.actions; [ЭКСПОРТ МЕТОДОВ ХРАНИЛИЩА]
                                    export default DraftSlice.reducer;
                                `
                            )}
                        </SyntaxHighlighter>
                    </div>
                    <div className="step">
                        <h4>3)</h4>
                        <p className="text">Все данные собираются и сохраняются в хранилищах при каждом рендере приложения/страницы
                            в файле Store.ts.
                        </p>
                        <span className="path">[/ReactComponents/Store.ts]</span>
                    </div>
                    <div className="step">
                        <h4>4)</h4>
                        <p>Чтобы сохранить данные в хранилище нужно использовать useAppDispatch, создав на основе него переменную dispatch,
                            находящийся в hooks.ts и нужны вам метод хранилища(слайса)
                        </p>
                        <span className="path">[/ReactComponents/Hooks/hooks.ts]</span>
                        <SyntaxHighlighter language="tsx" style={oneDark} customStyle={{ fontSize: "18px" }}>
                            {dedent(
                                `
                                import { useAppDispatch } from "./Hooks/hooks";
                                import { update } from "./Store/DraftSlice";

                                const dispatch = useAppDispatch();
                                dispatch(update(5));
                                `
                            )}
                        </SyntaxHighlighter>
                    </div>
                    <div className="step">
                        <h4>4)</h4>
                        <p className="text">Чтобы получить данные из хранилища(слайса) нужно импортировать useAppSelector,
                            находящийся в hooks.ts.
                        </p>
                        <span className="path">[/ReactComponents/Hooks/hooks.ts]</span>
                        <SyntaxHighlighter language="tsx" style={oneDark} customStyle={{ fontSize: "18px" }}>
                            {dedent(
                                `
                                import { useAppSelector } from "./Hooks/hooks";

                                const num = useAppSelector(state => state.Draft)
                                [Draft - ИДЕНТИФИКАТОР КОТОРЫЙ ВЫ УСТАНОВИЛИ В store.ts с ссылкой на хранилище]
                                `
                            )}
                        </SyntaxHighlighter>
                    </div>
                </div>
            ) : null}

        </React.Fragment>
    );
}

export default TestArea;